import React, { useState } from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  return (
    <footer className="footer">
      <div className="footer-main">
        {/* Logo & Description */}
        <div className="footer-brand">
          <div className="footer-logo-row">
            <img
              src="/Sndp/logo.png"
              alt="Logo"
              className="footer-logo-img"
            />
            <div className="footer-brand-info">
              <h3 className="footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
              <p className="footer-brand-desc">
                We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru, 
                a revered saint and social reformer from Kerala, India (1854-1928).
              </p>
              <div className="footer-socials">
                <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Us Column */}
        <div className="footer-contact">
          <h4 className="footer-column-title">Contact Us</h4>
          <div className="footer-contact-list">
            <div className="footer-contact-item">
              <FiMapPin size={20} color="#FFC501" />
              <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
            </div>
            <div className="footer-contact-item">
              <FiPhone size={20} color="#FFC501" />
              <span>+91 84524145547</span>
            </div>
            <div className="footer-contact-item">
              <FiMail size={20} color="#FFC501" />
              <span>sndpyogamuk@gmail.com</span>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4 className="footer-column-title">Quick Links</h4>
          <ul className="footer-nav">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#history">History</a></li>
            <li><a href="#organization">Organization</a></li>
            <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
            <li><a href="#articles">Articles</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="footer-newsletter">
          <h4 className="footer-column-title">Newsletter</h4>
          <p className="newsletter-desc">Subscribe to our Newsletter</p>
          <div className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="button">Subscribe</button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <span className="footer-copyright">
          © 2025 Pravasi SNDP Yogam. All rights reserved.
        </span>
        <div className="footer-bottom-links">
          <a href="#terms">Terms of Use</a>
          <a href="#privacy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
